import React, { useState } from "react";
import {
  IconArrowRight,
  IconChevronLeft,
  IconClose,
  IconTooman,
} from "../../assets/icons";
import { Button, Col, Container, Offcanvas, Row } from "react-bootstrap";
import SplitNumber from "./SplitNumber";
import { Link } from "react-router-dom";
function TitleH6WithLine({ titleText, titleTag, items, sliderCountItem }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="mt-2 px-1 mb-3 d-flex align-items-center justify-content-between">
        <div xs="auto" className=" my-auto">
          {titleTag == "h2" ? (
            <h2
              className="fw-bold mb-0 fs-09"
              style={{
                borderRight: "3px solid #ff6600",
                borderRadius: "3px",
                paddingRight: "5px",
              }}
            >
              {titleText}
            </h2>
          ) : (
            <h1
              className="fw-bold mb-0 fs-09"
              style={{
                borderRight: "3px solid #ff6600",
                borderRadius: "3px",
                paddingRight: "5px",
              }}
            >
              {titleText}
            </h1>
          )}
        </div>
        <div
          className="mx-2 my-auto"
          style={{ background: "#e9e9e9", height: "1px", flexGrow: "1" }}
        ></div>
        {items?.length > 2 && (
          <div
            xs="auto"
            className="fs-07 my-auto very-small-svg pe-0"
            onClick={handleShow}
          >
            مشاهده همه
          </div>
        )}
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="bottom"
        style={{ height: "90%" }}
      >
        <Offcanvas.Header>
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="fs-08 fw-bold">
              <IconArrowRight fillColor="#000" onClick={handleClose} />
              <span className="ms-1">{titleText}</span>
            </div>
            <div
              className="very-small-svg fs-075 border rounded-pill bg-light px-2 py-1"
              onClick={handleClose}
            >
              <IconClose fillColor="#444" />
              بستن
            </div>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="bg-light">
          {items?.map((item) => (
            <Container className="border  shadow-sm rounded-3 mb-3 bg-white">
              <Row className="">
                <Col xs="auto" className="px-0" style={{ height: "67.5px" }}>
                  <img
                    src={`${
                      process.env.REACT_APP_API_URL + item.imageUrl
                    }?width=100`}
                    alt=""
                    className="rounded-3 rounded-end-0"
                    width={90}
                  />
                </Col>
                <Col className="pe-0 my-auto">
                  <div
                    className="fw-bold fs-075"
                    // style={{ paddingTop: "10px" }}
                  >
                    {item.name}
                  </div>
                  {item.hasReserveDetail_V2 &&
                    item.originalPrice > item.price && (
                      <div className="fs-065 mt-2 text-danger">
                        <SplitNumber number={item.originalPrice - item.price} />
                        <span className="ps-1">تخفیف</span>
                      </div>
                    )}

                  {!item.hasReserveDetail_V2 && (
                    <div className="fs-065 mt-1 text-secondary">
                      رزرو موقتا غیر فعال
                    </div>
                  )}
                </Col>

                <Col xs="auto" className=" text-end  pe-2 ">
                  <div>
                    {item.hasReserveDetail_V2 ? (
                      <div
                        className="fs-08 fw-bold medium-svg"
                        style={{ paddingTop: "10px" }}
                      >
                        <SplitNumber number={item.price} />
                        <IconTooman
                          fillColor="#000"
                          style={{ marginTop: "-5px" }}
                        />
                      </div>
                    ) : (
                      <div
                        className="fs-065 text-secondary pe-1"
                        style={{ paddingTop: "12px" }}
                      >
                        به زودی ...
                      </div>
                    )}
                    {item.hasReserveDetail_V2 ? (
                      <Link to={`/details/${item.urlName}`}>
                        <button
                          className="fs-075 btn text-success rounded-pill"
                          style={{
                            padding: "2px 15px",
                            border: "1px solid #a5ddcc",
                            background: "#e6f7f2",
                            marginTop: "5px",
                          }}
                        >
                          خرید بلیط
                        </button>
                      </Link>
                    ) : (
                      <Link to={`/details/${item.urlName}`}>
                        <Button
                          variant="outline-secondary"
                          className="fs-075 rounded-pill opacity-50 bg-light"
                          style={{
                            padding: "2px 15px",
                            marginTop: "6px",
                          }}
                        >
                          مشاهده
                        </Button>
                      </Link>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          ))}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default TitleH6WithLine;
